<template>
  <v-container fluid fill-height class="pa-0 ma-0 white" id="profile">
    <v-layout column class="pa-0 ma-0">
      <v-card class="elevation-0">
        <v-card-text>
          <h3 style="margin: 0% auto;"><b>Permintaan Pengiriman {{kodePenjualan}}</b> ({{komoditas}} {{kuantitas}}.00 Ton)</h3>
          <small>Kontrak > {{kodePenjualan}}</small>
        </v-card-text>

        <v-card-text class="pa-0">
          
          <v-tabs v-model="selectedTab">
            <v-tab ripple href="#tab-1">
              Pesanan Pengiriman
            </v-tab>            
            <v-tab ripple href="#tab-2">
              Alokasi Pengiriman
            </v-tab>
            <v-tab ripple href="#tab-3">
              Pergerakan Barang
            </v-tab>            
            
            <v-tabs-items v-model="selectedTab">
              <v-tab-item id="tab-1">
                <v-card>
                  <detail-komoditas></detail-komoditas>
                </v-card>
              </v-tab-item>
            
              <v-tab-item id="tab-2">
                <v-card flat>
                  <alokasi-pengiriman></alokasi-pengiriman>
                </v-card>
              </v-tab-item>
            
              <v-tab-item id="tab-3">
                <v-card flat>
                  <pesanan-pengiriman></pesanan-pengiriman>
                  <!-- <tambahkan-promosi></tambahkan-promosi> -->
                </v-card>
              </v-tab-item>

            </v-tabs-items>
          </v-tabs>          
        </v-card-text>

      </v-card>   
    </v-layout>
  </v-container>     
</template>

<script>
import { getUserById } from '@/api/user';

import VWidget from '@/components/VWidget';
import DetailKomoditas from '@/components/komoditaslogistik/DetailKomoditas'
import AlokasiPengiriman from '@/components/komoditaslogistik/AlokasiPengiriman'
import PesananPengiriman from '@/components/komoditaslogistik/PesananPengiriman'
export default {
  components: {
    VWidget,
    DetailKomoditas,
    AlokasiPengiriman,
    PesananPengiriman
  },
  data () {
    return {
      kodePenjualan: localStorage.kontrakKodePenjualan,
      komoditas: localStorage.kontrakKomoditas,
      kuantitas: localStorage.kontrakKuantitas,
      selectedTab: null,
      status: false
    };
  },
  computed: {
   
    user () {
      let Origin = {
        name: 'KomoditasLogistik',
        avatar: '',
      };
      let user = getUserById(this.$route.params.uuid);
      return Object.assign(Origin, user);
    }    
  },
};
</script>